module.exports = __webpack_public_path__ + "assets/img/block-left-hover-d9420af5.png";